import { Modal } from '../ui/Modal';
import { UserForm, UserFormData } from './UserForm';
import { User } from '../../lib/api/users';

interface UserEditModalProps {
  user: User;
  isOpen: boolean;
  onClose: () => void;
  onUpdate: (data: UserFormData) => Promise<void>;
  isLoading?: boolean;
}

export function UserEditModal({ user, isOpen, onClose, onUpdate, isLoading }: UserEditModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Edit User">
      <UserForm user={user} onSubmit={onUpdate} onCancel={onClose} isLoading={isLoading} />
    </Modal>
  );
}
